import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { tID } from '../../utils/utils'
import { ConfirmationModal } from '../confirmationModal/ConfirmationModal'
import {
  ProviderCalendarEditSessionModalityScopeContent,
  ScopeSelection,
} from '../providerCalendarEditSessionModalityScopeContent/ProviderCalendarEditSessionModalityScopeContent'

export type ProviderCalendarEditSessionModalityScopeModalProps = {
  visible: boolean
  onRequestClose: () => void
  onConfirmationButtonPress: () => void
  confirmButtonLoading?: boolean
  confirmButtonDisabled?: boolean
  upcomingAppointmentsCount: number
  scopeSelection: ScopeSelection
  setScopeSelection: (scopeSelection: ScopeSelection) => void
}

export const ProviderCalendarEditSessionModalityScopeModal: FunctionComponent<
  ProviderCalendarEditSessionModalityScopeModalProps
> = ({
  visible,
  onRequestClose,
  upcomingAppointmentsCount,
  onConfirmationButtonPress,
  confirmButtonLoading,
  confirmButtonDisabled,
  scopeSelection,
  setScopeSelection,
}) => {
  return (
    <ConfirmationModal
      testID={tID('ProviderCalendarEditSessionModalityScopeModal')}
      visible={visible}
      modalTitle={
        <FormattedMessage
          defaultMessage='Which sessions do you want to update?'
          description='Title for the scope selection modal when editing recurring session modality'
        />
      }
      modalContents={
        <ProviderCalendarEditSessionModalityScopeContent
          upcomingAppointmentsCount={upcomingAppointmentsCount}
          scopeSelection={scopeSelection}
          onScopeSelectionChange={setScopeSelection}
        />
      }
      confirmationButtonText={<FormattedMessage defaultMessage='Save' description='Confirm button in scope modal' />}
      cancelButtonText={<FormattedMessage defaultMessage='Cancel' description='Cancel button in scope modal' />}
      onConfirmationButtonPress={onConfirmationButtonPress}
      onRequestClose={onRequestClose}
      confirmButtonLoading={confirmButtonLoading}
      confirmButtonDisabled={confirmButtonDisabled}
      showCloseIcon
      closeOnScrim={false}
      singleLineButtons
    />
  )
}
